import { observer } from 'mobx-react-lite';

import { TableRow } from 'app/components/common/Table/TableRow';
import { UserInfo } from 'app/components/common/UserInfo';
import { useModelWithArguments } from 'app/hooks/useViewModel';
import { UserLevelSelect } from 'app/components/UserLevelSelect';
import { Routes } from 'src/types/routes';
import { UserProfile } from 'common/types/models/user';
import { UserViewModel } from 'app/viewModels/components/UserViewModel';

type Props = {
    userId: string,
};

export const UserRow = observer(({ userId }: Props) => {
    const {
        changePremiumLevel,
        user,
        name,
        isLoading,
    } = useModelWithArguments(UserViewModel, userId);

    const userCreateAtDate = new Date(user.created_at).toLocaleDateString('en-GB');
    const userName = name || '-';

    return (
        <TableRow
            to={Routes.Dashboard.UserInnerPage(user.id)}
            isLoading={isLoading}
        >
            <UserInfo
                userName={userName}
                email={UserProfile.getEmail(user)}
            />

            <span className="p1-regular dark-violet">
                {userCreateAtDate}
            </span>

            <UserLevelSelect
                currentLevel={user.premium_level}
                onSelectLevel={changePremiumLevel}
            />
        </TableRow>
    );
});
